import React from 'react';
import { Image, Type } from '../../../Cloud.model';
import { InvertOrderName } from './ImageNameInverted.config';

export interface UHCImageNameProps {
    image: Image,
    showBits: boolean,
    showApplicationVersion?: boolean
    showApplication?: boolean
    showOSVersion?: boolean
    invertOrderName?: boolean
    showSO?:boolean
}

const isInvertOrderName = (image: UHCImageNameProps['image'],)=>{
    return image.type === 'app' && InvertOrderName.includes(image.application.shortName as any)
}

const getOperationalSystem = (
    image: UHCImageNameProps['image'],
    showBits: UHCImageNameProps['showBits'],
    showOSVersion: UHCImageNameProps['showOSVersion']) => {

    const bits = (showBits && image.operationalSystem.arch) ? `${image.operationalSystem.arch} bits` : '';
    const version = (showOSVersion) ? image.operationalSystem.version : '';

    return `${image.operationalSystem.name} ${bits} ${version}`
}

const getApplication = (image: UHCImageNameProps['image'],
    showApplicationVersion: UHCImageNameProps['showApplicationVersion'],
) => {
    return `${image.application.name} ${showApplicationVersion ? image.application.version : ''}`
}

const getSoApp = (
    image:UHCImageNameProps['image'],
    showBits:UHCImageNameProps['showBits'],
    showApplicationVersion:UHCImageNameProps['showApplicationVersion'],
    showOSVersion:UHCImageNameProps['showOSVersion'],
    isShowAppName: boolean
)=>{
    return (
        <>
            {getOperationalSystem(image, showBits, showOSVersion)}
            {isShowAppName && ` + ${getApplication(image, showApplicationVersion)}`}
        </>
    )
}

const getAppSo = (
    image:UHCImageNameProps['image'],
    showBits:UHCImageNameProps['showBits'],
    showApplicationVersion:UHCImageNameProps['showApplicationVersion'],
    showOSVersion:UHCImageNameProps['showOSVersion'],
    isShowAppName: boolean

)=>{
    return (
        <>
            {isShowAppName && `${getApplication(image, false)} - `}
            {getOperationalSystem(image, showBits, showOSVersion)}
        </>
    )
}

export const UHCImageName: React.FC<UHCImageNameProps> = ({
    image,
    showBits,
    showApplicationVersion = true,
    showApplication = true,
    showOSVersion = false,
    showSO = true}: UHCImageNameProps) => {
        
    const isInvert = isInvertOrderName(image);
    const isShowAppName = (image.type === Type.APP && showApplication);

    if(showSO && showApplication){
        return (
            isInvert ? 
            getAppSo(image, showBits, showApplicationVersion, showOSVersion, isShowAppName):
            getSoApp(image, showBits, showApplicationVersion, showOSVersion, isShowAppName)
        )
    }

    if(showSO){
        return <>{getOperationalSystem(image, showBits, showOSVersion)}</>
    }

    if(showApplication){
        return <>{getApplication(image, showApplicationVersion)}</>
    }

    return <> - </>

}
